// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"FormMap_buttonWrapper__N5RIj","svgWrapper":"FormMap_svgWrapper__Ijaih"};